/* eslint-disable indent */
import React, { FC } from 'react';
import { View } from 'react-native';

import { Element, notchBottom, scale } from '@components/frame';
import { isWeb } from '@helpers';
import TouchableElement from '@components/common/touchableElement';

import Svg from '@styles/icons/svg';
import { ColorFunction } from '@styles/colors/types';
import { ImageHandlingDisplayMode } from '@v2/components/imageHandling/types/types.d';

interface ThumbnailMobileBottomProps {
  C: ColorFunction;
  setMode: (mode: ImageHandlingDisplayMode) => void;
}

const ThumbnailMobileBottom: FC<ThumbnailMobileBottomProps> = ({ C, setMode }) => {
  return (
    <Element
      {...{
        config: {
          zIndex: 100,
          position: {
            bottom: 0,
            left: 0,
            right: 0,
          },
          height: 60 + notchBottom,
          backgroundColor: C('Background / Dark / menuApp', !isWeb),
        },
      }}
    >
      <Element
        {...{
          config: {
            position: {
              top: 4,
              right: 112,
            },
            height: 44,
            width: 44,
          },
        }}
      >
        <TouchableElement onPress={() => setMode(ImageHandlingDisplayMode.PICTURE)}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              ]}
            >
              <Svg icon="gallery" width={scale(20)} height={scale(20)} />
            </View>
          )}
        </TouchableElement>
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: 4,
              right: 20,
            },
            height: 44,
            width: 44,
          },
        }}
      >
        <TouchableElement onPress={() => {}}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              ]}
            >
              <Svg icon="more" width={scale(20)} height={scale(20)} />
            </View>
          )}
        </TouchableElement>
      </Element>
    </Element>
  );
};

export default ThumbnailMobileBottom;
